import { Component, OnInit } from "@angular/core";
import { Platform } from "@ionic/angular";
import { SafeArea } from "capacitor-plugin-safe-area";
import { ScreenOrientation } from "@ionic-native/screen-orientation/ngx";
import { MobileDataService } from "src/app/services/mobile-data/mobile-data.service";

@Component({
  selector: "app-sizing",
  templateUrl: "./sizing.component.html",
  styleUrls: ["./sizing.component.scss"],
})
export class SizingComponent implements OnInit {
  public insets: any;
  public keyboardVisible: boolean;

  constructor(
    private platform: Platform,
    private mobileData: MobileDataService,
    private screenOrientation: ScreenOrientation
  ) {
    if (this.platform.is("ios") ) {
      this.screenOrientation.onChange().subscribe(() => this.applySafeArea());
    }
  }

  ngOnInit() {
    if (this.platform.is("capacitor")&&this.platform.is("ios")) {
      this.createCustomVHVW();
      if (this.platform.is("ios")) {
        this.applySafeArea();
      }
    }
    this.adjustIosWebLandscapeHeight();
    this.keyboardVisibilityListener();
    //  console.log("<------ Hi I am Sizing Almighty -------->")
  }

  createCustomVHVW() {
    if (window.innerHeight > window.innerWidth) {
      document.documentElement.style.setProperty(
        "--vh",
        `${window.innerHeight * 0.01}px`
      );
      document.documentElement.style.setProperty(
        "--vw",
        `${window.innerWidth * 0.01}px`
      );
    }
    //when the app is started in landscape mode
    else {
      document.documentElement.style.setProperty(
        "--vh",
        `${window.innerWidth * 0.01}px`
      );
      document.documentElement.style.setProperty(
        "--vw",
        `${window.innerHeight * 0.01}px`
      );
    }
  }

  createSafeArea() {
    document.documentElement.style.setProperty(
      "--sab",
      `${this.insets.insets.bottom}px`
    );
    document.documentElement.style.setProperty(
      "--sat",
      `${this.insets.insets.top}px`
    );
    document.documentElement.style.setProperty(
      "--sar",
      `${this.insets.insets.right}px`
    );
    document.documentElement.style.setProperty(
      "--sal",
      `${this.insets.insets.left}px`
    );
    //  console.log("<------ Sizing Almighty --- Custom Style Baby -------->",document.documentElement.style);
  }

  async applySafeArea() {
    this.insets = await SafeArea.getSafeAreaInsets();
    this.mobileData.insets = this.insets;
    this.createSafeArea();
    document.body.style.backgroundColor = "black";
    document.documentElement.style.backgroundColor = "black";
    this.checkOrientationAndAdjust();
  }

  adjustIosWebLandscapeHeight() {
    if (this.platform.is("ios") && !this.platform.is("capacitor")) {
      document.body.style.backgroundColor = "black";
      document.documentElement.style.backgroundColor = "black";
      document.body.style.height = `calc(100% - env(safe-area-inset-bottom))`;
    }
  }

  keyboardVisibilityListener() {
    this.platform.keyboardDidShow.subscribe((ev) => {
      const { keyboardHeight } = ev;
      this.adjustMobileWebviewOnKeyboardVisible(keyboardHeight);
      this.keyboardVisible = true;
    });

    this.platform.keyboardDidHide.subscribe(() => {
      this.keyboardVisible = false;
      this.adjustMobileWebviewOnKeyboardVisible(0);
    });
  }

  adjustMobileWebviewOnKeyboardVisible(margin) {
    if ((this.platform.is("ios") || this.platform.is("android")) && !this.platform.is("capacitor")) {
      const availableGrids = document.getElementsByName("mobile-web-margin-bottom");

      if (availableGrids.length > 0) {
          availableGrids[availableGrids.length-1].style.marginBottom = margin + "px";
      }
    }
  }

  checkOrientationAndAdjust() {
    document.body.style.height = `calc(100% - ${this.insets.insets.top}px)`;
    document.documentElement.style.marginTop = `${this.insets.insets.top}px`;
  }

  applyHorizontalSafeArea() {
    document.documentElement.style.marginLeft = `${this.insets.insets.left}px`;
    document.documentElement.style.marginRight = `${this.insets.insets.right}px`;
    document.body.style.width = `calc(100% - ${this.insets.insets.left + this.insets.insets.left}px)`;
  }
  
}
